import { Dispatch } from 'redux'
import { IGetShiftsThunkParams } from 'models/Shift'
import { API } from 'network'
import {
  GetUpshifterShifts,
  GetUpshifterShiftsErrors,
  UpshifterShiftsFetching,
  UpshifterShiftsSetHasMore,
  ClearUpshifterShiftsReducer,
  UpshifterShiftsFavoriteBusiness,
  UpshifterShiftsUnfavoriteBusiness,
  GetUpshifterShiftsWithoutConcat,
} from './actions'

export type TUpshifterShiftsActions =
  | ReturnType<typeof GetUpshifterShifts>
  | ReturnType<typeof GetUpshifterShiftsWithoutConcat>
  | ReturnType<typeof GetUpshifterShiftsErrors>
  | ReturnType<typeof UpshifterShiftsFetching>
  | ReturnType<typeof ClearUpshifterShiftsReducer>
  | ReturnType<typeof UpshifterShiftsSetHasMore>
  | ReturnType<typeof UpshifterShiftsFavoriteBusiness>
  | ReturnType<typeof UpshifterShiftsUnfavoriteBusiness>

export const getUpshifterShifts = ({
  params,
  preventConcatenate,
}: IGetShiftsThunkParams) => async (
  dispatch: Dispatch<TUpshifterShiftsActions>,
) => {
  if (!params?.page) {
    dispatch(ClearUpshifterShiftsReducer())
    dispatch(UpshifterShiftsSetHasMore(true))
  }
  dispatch(UpshifterShiftsFetching(true))
  try {
    const response = await API.Shifts.getShifts(params)
    if (preventConcatenate) {
      dispatch(GetUpshifterShiftsWithoutConcat(response))
    } else {
      dispatch(GetUpshifterShifts(response))
    }
    return response
  } catch (error) {
    dispatch(
      GetUpshifterShiftsErrors({
        code: error.code,
        message: error.message,
      }),
    )

    return error
  } finally {
    dispatch(UpshifterShiftsFetching(false))
  }
}
